import { render } from "./PackingView.vue?vue&type=template&id=47172959&scoped=true"
import script from "./PackingView.vue?vue&type=script&lang=js"
export * from "./PackingView.vue?vue&type=script&lang=js"

import "./PackingView.vue?vue&type=style&index=0&id=47172959&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47172959"]])

export default __exports__